import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-warehouse-receiving-orders',
  templateUrl: './warehouse-receiving-orders.component.html',
  styleUrls: ['./warehouse-receiving-orders.component.css']
})
export class WarehouseReceivingOrdersComponent implements OnInit {



  constructor() { }

  ngOnInit() {
  }

}
